export default {
  bind: function (el, bindings, vnode) {
  },
  inserted: function(el, bindings) {
    let vhtml = bindings.value;

    el.insertAdjacentHTML('afterend', vhtml);
    el.parentNode.removeChild(el);
  },
  update: function (el, bindings) {
  },
  unbind: function (el, bindings) {
  }
}


// WEBPACK FOOTER //
// ./src/plugins/vue-ahtml/directive.js